/**
 * 포인트/쿠폰 탭 버튼 컴포넌트
 */
import type { TabType, PointsTranslations } from './types';

interface PointsTabsProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  translations: PointsTranslations;
}

export function PointsTabs({ activeTab, onTabChange, translations: t }: PointsTabsProps) {
  return (
    <div className="flex items-center gap-0 h-[49px] w-full max-w-[347px] mx-auto mb-[14px]">
      {/* Points Tab */}
      <button
        onClick={() => onTabChange('points')}
        className={`relative flex-1 h-[49px] rounded-[5px] transition-all ${
          activeTab === 'points' ? 'bg-muted' : ''
        }`}
      >
        <div className="flex items-center justify-center h-full">
          <span className={`text-[14px] font-medium leading-[21px] ${
            activeTab === 'points' ? 'text-foreground' : 'text-muted-foreground'
          }`}>
            {t.tabs.points}
          </span>
        </div>
        {activeTab === 'points' && (
          <div className="absolute left-1/2 -translate-x-1/2 bottom-[5.25px] w-[calc(100%-20px)] h-[1.75px] rounded-full bg-gradient-to-b from-primary to-primary-hover" />
        )}
      </button>

      {/*
        Brand Coupons Tab — #456 (G5) 임시 숨김 처리.
        쿠폰 기능 BE 할인 적용 로직 미연결. 정상화 시점에 복원.
      */}
    </div>
  );
}
